const Leo = require("./leo").default;

exports.default = {
  Leo
};
